import { render } from "./dataTreeTable.vue?vue&type=template&id=5e2c0047"
import script from "./dataTreeTable.vue?vue&type=script&lang=js"
export * from "./dataTreeTable.vue?vue&type=script&lang=js"

import "./dataTreeTable.vue?vue&type=style&index=0&id=5e2c0047&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__